export const intuitColors = {
	// keep fig at 100
	fig: '#275582',

	// all others at 30
	kiwi: '#AFFFB9',
	blueberry: '#A0CFFF',
	agave: '#AEEFF5', // TODO: source 30-shade was garbled; nearest light-tint
	honey: '#FEDB5E',
	persimmon: '#FFBE6F',
	watermelon: '#FFB5C6', // TODO: interpolate between 40 (#FF9BA4) and 20 (#FFD4D8)
	dragonfruit: '#FFB5DF',
	eggplant: '#D0C2FF',
	pepper: '#C3CED5',
	kale: '#CFE0E5', // TODO: light tint from Kale-100 (#325F6B)
	cardamom: '#F6FBF8', // TODO: very light tint from Cardamom-100 (#ECF6EF)
	ice: '#E9F6F8', // TODO: light tint from Ice-120 (#BEE3E7)
	tofu: '#F7F7F2', // TODO: light tint; Tofu-110 was #EAEAE3
	black: '#000000',
	white: '#FFFFFF',
} as const;
